var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookIconShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1098 0.0117188C7.57168 0.144861 10.7353 1.40701 13.2224 3.43021V19.6757C13.2224 19.7075 13.2213 19.7389 13.2186 19.7699C10.6457 17.8141 7.40733 16.6487 3.88911 16.6487C3.6282 16.6487 3.11133 16.4594 3.11133 15.5134V1.13515C3.11133 0.563668 3.54506 0.0910103 4.1098 0.0117188Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55559 3.42055C1.42149 3.41433 1.28699 3.40923 1.15208 3.40527C0.500459 3.47512 0 3.8915 0 4.39493V19.8647C0 20.698 0.671178 20.9999 0.972222 20.9999C3.11111 20.9999 7.19445 19.2972 11.6623 20.8107C11.6631 20.803 11.6661 20.9032 11.6667 20.7822C8.82619 18.558 4.71054 18.3512 3.69444 18.3512C2.33333 17.9728 1.55558 17.0269 1.55556 15.135L1.55559 3.42055Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 20.8107C11.6667 20.7213 11.6667 20.8774 11.6667 20.8107V20.8107Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4444 3.42038C26.5785 3.41423 26.713 3.40919 26.8479 3.40527C27.4995 3.47437 28 3.88627 28 4.38429V19.6877C28 20.5121 27.3288 20.8107 27.0278 20.8107C24.8889 20.8107 20.8056 19.1263 16.3377 20.6235C16.3369 20.616 16.3339 20.715 16.3333 20.5954C19.1738 18.3951 23.2895 18.1905 24.3056 18.1905C25.6667 17.8162 26.4444 16.8804 26.4444 15.0089L26.4444 3.42038Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 20.6235C16.3333 20.5351 16.3333 20.6895 16.3333 20.6235V20.6235Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8902 0C20.4283 0.132586 17.2647 1.38947 14.7776 3.40421V19.5818C14.7776 19.6135 14.7787 19.6448 14.7814 19.6757C17.3543 17.728 20.5927 16.5675 24.1109 16.5675C24.3718 16.5675 24.8887 16.3789 24.8887 15.4369V1.11874C24.8887 0.549644 24.4549 0.0789604 23.8902 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIconShortcut);
export default __webpack_public_path__ + "static/media/BookIconShortcut.d8677260411a2f2d690cf898b3457b49.svg";
export { ForwardRef as ReactComponent };